export const siteSearchKeys = [
    { name: 'name.text', weight: 1 },
    { name: 'contactDetails.address.line1', weight: 0.5 },
    { name: 'contactDetails.address.line2', weight: 0.5 },
    { name: 'contactDetails.address.city', weight: 0.5 }
];
//# sourceMappingURL=site-search-keys.js.map